export const DEFAULTS = {
  TARGET_SUCCESS_SCORE: 100,
  SUCCESS_INCREMENT: 10,
  PENALTY_INCREMENT: 15,
  CENTER_DIV_WIDTH_PX: 100,
  LINE_WIDTH_PX: 1.2,
} as const;

export const LINE_ANIM_DURATION_MS = 1000;
